// extracted by mini-css-extract-plugin
export default {"ellipsis":"HKKbZgFQ1Zx88UmEj2jf","wrapper":"IhXSrEjqQTHpey1CF3CI","disabled":"pFS52tTEHlsYV8e3jMIS","input":"X1zZu0RvyKJlc8OUirKo","spin":"uClwk8Ws8Mx6MFQRUi9_"};